import { useState, useEffect, useMemo } from "react";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import PropTypes from "prop-types";
import DashboardNavbarCustom from "examples/Navbars/DashboardNavbarCustom";
import { Grid } from "@mui/material";
import "./style.css";
import SoftBox from "components/SoftBox";
import { SearchDataUserWithPagination } from "api/UserAPI";
import SearchUserManager from "./data/SearchUserManager";
import UserManagerTables from "./data/UserManagerTable";

function Tables({ workingPage, childPage }) {
  const [totalElements, setTotalElements] = useState(0);
  const [curPage, setCurPage] = useState(0);
  const [rowsCount, setRowsCount] = useState(10);
  const [userData, setUserData] = useState([]);
  const [searchData, setSearchData] = useState({
    username: null,
    fullName: null,
    enabled: 2,
    page: curPage,
    size: rowsCount,
    phone: null,
    email: null,
  });

  // khi curPage hoặc rowsCount thay đổi, useEffect sẽ update searchData.page và searchData.size
  useEffect(() => {
    setSearchData((prev) => ({ ...prev, page: curPage, size: rowsCount }));
  }, [curPage, rowsCount]);

  useEffect(() => {
    setCurPage(0);
  }, [rowsCount]);

  //gọi lại dữ liệu khi thay đổi searchData
  useEffect(() => {
    SearchDataUserWithPagination(searchData)
      .then((data) => {
        if (data.object) {
          setUserData(data.object.users);
          setTotalElements(data.object.totalElements);
        }
      })
      .catch((error) =>
        // eslint-disable-next-line no-console
        console.error("Error fetching users", error)
      );
  }, [searchData.page, searchData.size]);

  //--CLICK BUTTON SEARCH TO FIND DATA
  const clickToSearch = () => {
    setCurPage(0);
    SearchDataUserWithPagination(searchData)
      .then((data) => {
        if (data.object) {
          setUserData(data.object.users);
          setTotalElements(data.object.totalElements);
        }
      })
      .catch((error) =>
        // eslint-disable-next-line no-console
        console.error("Error fetching users", error)
      );
  };

  //--REFRESH DATA AT CURRENT PAGE
  const refreshDataAfterChage = () => {
    SearchDataUserWithPagination(searchData)
      .then((data) => {
        if (data.object) {
          setUserData(data.object.users);
          setTotalElements(data.object.totalElements);
        }
      })
      .catch((error) =>
        // eslint-disable-next-line no-console
        console.error("Error fetching users", error)
      );
  };
  const renderData = useMemo(
    () => (
      <UserManagerTables
        data={userData}
        totalElements={totalElements}
        curPage={curPage}
        setCurPage={setCurPage}
        rowsCount={rowsCount}
        setRowsCount={setRowsCount}
        refreshDataAfterChage={refreshDataAfterChage}
      />
    ),
    [curPage, rowsCount, totalElements, userData]
  );

  return (
    <DashboardLayout>
      <DashboardNavbarCustom page={workingPage} childPage={childPage} />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Grid container>
            <Grid item xs={0.2} sm={0.2} xl={0.2} />
            <Grid item xs={11.6} sm={11.6} xl={11.6}>
              <SearchUserManager
                clickSearch={clickToSearch}
                setSearchData={setSearchData}
                searchData={searchData}
              />
            </Grid>
            <Grid item xs={0.2} sm={0.2} xl={0.2} />
            <Grid item xs={0.2} sm={0.2} xl={0.2} />
            <Grid item xs={11.6} sm={11.6} xl={11.6}>
              {renderData}
            </Grid>
            <Grid item xs={0.2} sm={0.2} xl={0.2} />
          </Grid>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
}

Tables.defaultProps = {
  workingPage: "",
  childPage: [],
};

Tables.propTypes = {
  workingPage: PropTypes.string,
  childPage: PropTypes.arrayOf(PropTypes.string),
};

export default Tables;
